import {
  DisplayRecipientsColumn as EmailDisplayRecipientsColumn,
  DisplayRecipientsValue as EmailDisplayRecipientsValue,
} from "features/Resources/Email/Components/DisplayRecipients";
import { DisplayAttendeesColumn, DisplayAttendeesValue } from "features/Resources/Meeting/Components/DisplayAttendees";
import {
  DisplayRecipientsColumn as MessageDisplayRecipientsColumn,
  DisplayRecipientsValue as MessageDisplayRecipientsValue,
} from "features/Resources/Message/Components/DisplayRecipients";
import { Email } from "features/Resources/Email/models";
import { Message } from "features/Resources/Message/models";
import { DisplayAssigneeColumn, DisplayAssigneeValue } from "features/Resources/Task/Components/DisplayAssignee";
import { Task } from "features/Resources/Task/models";
import { Meeting } from "features/Resources/Meeting/models";
import { Checkpoint } from "features/Resources/Checkpoint/models";
import { ActionSummary } from "../models";
import { CHECK_TARGET_LABELS } from "../constants";

export function DisplayRecipientsColumn({ action }: { action: ActionSummary }) {
  switch (action.actionType) {
    case "email":
      return <EmailDisplayRecipientsColumn recipients={(action.action as Email).to ?? []} />;
    case "meeting":
      return <DisplayAttendeesColumn attendees={(action.action as Meeting)?.attendees} />;
    case "message":
      return <MessageDisplayRecipientsColumn message={action.action as Message} />;
    case "task":
      return <DisplayAssigneeColumn task={action.action as Task} />;
    case "checkpoint":
      return <>{CHECK_TARGET_LABELS[(action.action as Checkpoint)?.checkTarget] || "Tasks"}</>;
    default:
      return null;
  }
}

export function DisplayRecipientsValue({ action }: { action: ActionSummary }) {
  switch (action.actionType) {
    case "email":
      return <EmailDisplayRecipientsValue email={action.action as Email} />;
    case "meeting":
      return <DisplayAttendeesValue meeting={action.action as Meeting} />;
    case "message":
      return <MessageDisplayRecipientsValue message={action.action as Message} />;
    case "task":
      return <DisplayAssigneeValue task={action.action as Task} />;
    case "checkpoint":
      return <>{CHECK_TARGET_LABELS[(action.action)?.checkTarget] || "Tasks"}</>;
    default:
      return null;
  }
}
